import React, { useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { changeDeal } from 'bundles/apex/deals/form/store/deal/actions';

import AddressForm from 'components/form/address';

export default function Address() {
  const dispatch = useDispatch();

  const deal = useSelector((state: any) => state.deal);
  const fields = useSelector((state: any) => state.fields);
  const invalidFields = useSelector((state: any) => state.invalidFields);

  const options = useMemo(() => {
    const options = {};

    for (const name of ['country', 'address', 'address2', 'city', 'state', 'zip', 'county']) {
      if (fields[name]) {
        options[name] = buildInputOptions(fields, invalidFields, name);
      }
    }

    return options;
  }, [fields, invalidFields]);

  if (Object.keys(options).length === 0) {
    return null;
  }

  return (
    <AddressForm
      countries={fields.country.options}
      options={options}
      value={deal}
      onChange={changes => dispatch(changeDeal(changes))}
    />
  );
}

function buildInputOptions(fields, invalidFields: string[], name: string) {
  return {
    hasError: invalidFields.includes(name),
    required: fields[name].required,
    show: !fields[name].hidden,
  };
}
